import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class SGAAuthInterceptor implements HttpInterceptor {

    constructor() { }

    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        const token = localStorage.getItem('userToken') || sessionStorage.getItem('userToken') || '';
        let userCPF: any = localStorage.getItem('userInfo') || sessionStorage.getItem('userInfo') || '';
        userCPF = userCPF != '' && userCPF != null && userCPF != 'null' && userCPF != undefined ? JSON.parse(userCPF).cpf_cnpj : '';
        
        let headers = req.headers;
        
        if (headers.has('Content-Type')) {
            headers = headers.delete('Content-Type');
        }
        
        if (req.method === 'POST' || req.method === 'PUT' || req.method === 'PATCH') {
            headers = headers.append('Content-Type', 'application/json');
        }
        
        if (token !== '') {
            headers = headers.append('Authorization', `Bearer ${token} ${userCPF}`);
        }
        
        const authReq = req.clone({ headers: headers });
        return next.handle(authReq);
    }
}



// WEBPACK FOOTER //
// /app/src/app/services/sga.auth.interceptor.service.ts